'use client';

import { useTranslations } from 'next-intl';
import { ListPageHeader } from '@terra/ui-design-system';

export function ExecutionsPageHeader() {
  const t = useTranslations('proxy.executions.page');

  return <ListPageHeader title={t('title')} subtitle={t('subtitle')} />;
}
